/*
 * AUFTRAG-51 (T6, 14.10.2026): Bereichs-Navigator der Produktübersicht + Bereichs-Finder + Serien-Finder.
 *
 * Eingebunden von sections/range-navigator.liquid (und, zum Einbau auf Serienseiten, von snippets/range-series-finder.liquid).
 * Daten: ein JSON je Bereich (serverseitig aus den Metafeldern, snippets/range-finder-rows.liquid), kein Nachladen.
 * Ohne JavaScript bleiben Kacheln und Serienkarten nutzbar (das Gerüst setzt die Klasse rn--js erst, wenn dieses Script läuft).
 *
 * Bausteine
 *   Model        Filtermodell über Zeilen (Bereiche = Regler über die vorhandenen Werte, Auswahl = Chips), Zustand <-> Adresse
 *   buildControls  Regler und Chips als DOM, hält den Zustand synchron
 *   AreaFinder   Bereichs-Finder: Filterleiste, Trefferzahl live, je Nenngröße eine Zeile mit aufklappbaren Optionen (F38), Vergleichen
 *   SeriesFinder Serien-Finder: kompakte Tabelle der Serie, Treffer hervorgehoben
 *   Navigator    Kacheln, Panel unter der Kachelreihe (nur eins offen), Tastatur, aria-expanded (Vorgänger, noch für range-series-finder)
 *   Bands        AUFTRAG-62: Querbänder, Serienkarte öffnet Filter und Modellliste der Serie unter dem Band
 * Öffentlich: window.CryRangeNav = { Model, AreaFinder, SeriesFinder }.
 */
(function () {
  'use strict';

  var D = document;
  var W = window;
  var REDUCED = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || D).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || D).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function track(name, params) {
    try { if (typeof W.cryonosTrack === 'function') W.cryonosTrack(name, params || {}); } catch (e) { /* Messung darf nie stören */ }
  }

  var i18n = { lang: 'en', t: {} };
  try { i18n = JSON.parse($('[data-rn-i18n]').textContent); } catch (e) { /* Seite ohne Navigator */ }
  var DE = i18n.lang === 'de';
  var T = i18n.t || {};
  var nf;
  try { nf = new Intl.NumberFormat(i18n.lang || 'en', { maximumFractionDigits: 1 }); } catch (e) { nf = { format: function (n) { return String(n); } }; }
  var nf2;
  try { nf2 = new Intl.NumberFormat(i18n.lang || 'en', { maximumFractionDigits: 2 }); } catch (e) { nf2 = nf; }
  function fmt(n) { return nf.format(n); }
  function fmt2(n) { return nf2.format(n); }
  function sub(str, map) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  /* Feste Bezeichnungen (Filter, Einheiten); Knopf- und Satztexte kommen aus den Section-Einstellungen (i18n.t). */
  var FIXED = {
    vol: ['Volume', 'Volumen'], hold: ['Hold time', 'Haltezeit'], neck: ['Neck opening', 'Halsöffnung'],
    hgt: ['Height', 'Höhe'], dia: ['Diameter', 'Durchmesser'], wt: ['Empty weight', 'Leergewicht'],
    pr: ['Operating pressure', 'Betriebsdruck'], ev: ['Evaporation (L/day)', 'Verdampfung (L/Tag)'], ep: ['Evaporation (%/day)', 'Verdampfung (%/Tag)'], wd: ['Withdrawal rate', 'Entnahmerate'],
    probe: ['Sample type', 'Probentyp'], sys: ['Storage system', 'Lagersystem'], ser: ['Series', 'Serie'],
    straws: ['Straws', 'Straws'], vials: ['Vials', 'Kryoröhrchen'], kryo: ['Cryoboxes', 'Kryoboxen'],
    S: ['Short canisters', 'Kanister kurz'], L: ['Long canisters', 'Kanister lang'], B: ['Racks', 'Racks'],
    samples: ['Samples', 'Proben'], days: ['days', 'Tage'], from: ['from', 'ab'], model: ['Model', 'Modell'],
    price: ['Price', 'Preis'], lo: ['from', 'von'], hi: ['to', 'bis'], max4: ['Maximum of four models', 'Höchstens vier Modelle'],
    s05: ['Straws 0.5 ml', 'Straws 0,5 ml'], s025: ['Straws 0.25 ml', 'Straws 0,25 ml'], v2: ['Vials 1.2/2 ml', 'Vials 1,2/2 ml'],
    /* AUFTRAG-75: Filter je Serie (Druckstufe, Rollen, Einsatz, Bauform, Betriebsdruck, Bauart, Zubehör, Zulassung) */
    kd: ['Pressure class', 'Druckstufe'], roll: ['Castors', 'Rollen'], use: ['Use', 'Einsatz'], form: ['Design', 'Bauform'], bar: ['Operating pressure', 'Betriebsdruck'],
    bau: ['Type', 'Bauart'], opt: ['Optional extras', 'Optional dazu'], zul: ['Approval', 'Zulassung'],
    withc: ['with castors', 'mit Rollen'], woc: ['without castors', 'ohne Rollen'], pbnote: ['with pressure building', 'mit Druckaufbau'],
    u_adr: ['transportable (ADR)', 'transportabel (ADR)'], u_fix: ['stationary', 'stationär'], f_v: ['vertical', 'vertikal'], f_h: ['horizontal', 'horizontal'],
    o_heber: ['Withdrawal device', 'Entnahmeheber'], o_kf: ['KF50 flange', 'KF50-Flansch'], b_s: ['Standard', 'Standard'], b_t: ['T model', 'T-Modell'],
    /* AUFTRAG-76 (2.1): Filter für Freezer, 2XL, T und DS */
    bag: ['Blood bags', 'Blutbeutel'], fs: ['Storage system', 'Lagersystem'], fs_rack: ['Racks', 'Racks'], fs_kan: ['Canisters', 'Kanister'],
    fp: ['Stored in', 'Lagerung in'], fp_gas: ['Gas phase', 'Gasphase'], fp_liq: ['Liquid phase', 'Flüssigphase'],
    cn: ['Number of canisters', 'Anzahl Kanister'], lg: ['Optional extras', 'Optional dazu'], lg_log: ['Data logger', 'Datenlogger'],
    nw: ['Neck opening', 'Halsöffnung'], nw_eng: ['narrow', 'eng'], nw_weit: ['wide', 'weit'], nc: ['Neck opening', 'Halsöffnung']
  };
  function tx(k) { var f = FIXED[k]; return f ? f[DE ? 1 : 0] : k; }

  var DEF = {
    vol: { field: 'v', type: 'range', unit: 'L' },
    hold: { field: 'hd', type: 'range', unit: 'd' },
    ev: { field: 'ev', type: 'range', unit: 'L/d', fmt: 2 },
    ep: { field: 'ep', type: 'range', unit: '%/d', fmt: 2 },
    neck: { field: 'nk', type: 'range', unit: 'mm' },
    hgt: { field: 'ht', type: 'range', unit: 'mm' },
    dia: { field: 'dm', type: 'range', unit: 'mm' },
    wt: { field: 'wt', type: 'range', unit: 'kg' },
    pr: { field: 'pr', type: 'range', unit: 'bar' },
    wd: { field: 'wd', type: 'range', unit: 'L/min' },
    probe: { type: 'chips', param: 'probe' },
    sys: { type: 'chips', param: 'sys' },
    ser: { type: 'chips', param: 'serie' },
    /* AUFTRAG-75: Auswahl-Filter aus Werten je Zeile (vals), Beschriftung lab(Wert, Zeilen); flag = erscheint auch, wenn nur ein Wert vorkommt und andere Modelle ihn nicht haben */
    kd: { type: 'chips', param: 'druck', vals: function (r) { return r.kd ? [r.kd] : []; }, order: ['LP', 'PB', 'MP', 'HP'],
      lab: function (v, rows) {
        var m = 0; rows.forEach(function (r) { if (r.kd === v && r.pr > m) m = r.pr; });
        return v + (m > 0 ? ' ' + fmt(m) + ' bar' : '') + (v === 'PB' ? ' · ' + tx('pbnote') : '');
      } },
    roll: { type: 'chips', param: 'rollen', vals: function (r) { return r.kd ? [r.ct > 0 ? 'yes' : 'no'] : []; }, order: ['yes', 'no'], lab: function (v) { return tx(v === 'yes' ? 'withc' : 'woc'); } },
    use: { type: 'chips', param: 'einsatz', vals: function (r) { return r.vr ? [r.ad ? 'adr' : 'fix'] : []; }, order: ['adr', 'fix'], lab: function (v) { return tx('u_' + v); } },
    form: { type: 'chips', param: 'bauform', vals: function (r) { return r.vr ? [r.hz ? 'h' : 'v'] : []; }, order: ['v', 'h'], lab: function (v) { return tx('f_' + v); } },
    bar: { type: 'chips', param: 'druckbar', vals: function (r) { return r.vr && r.pr > 0 ? [String(r.pr)] : []; }, num: true, lab: function (v) { return fmt(parseFloat(v)) + ' bar'; } },
    bau: { type: 'chips', param: 'bauart', vals: function (r) { return r.bau ? [r.bau] : []; }, order: ['S', 'T'], lab: function (v) { return tx('b_' + v.toLowerCase()); } },
    opt: { type: 'chips', param: 'zubehoer', flag: true, vals: function (r) { var a = []; if (r.ax & 1) a.push('heber'); if (r.ax & 2) a.push('kf'); return a; }, order: ['heber', 'kf'], lab: function (v) { return tx('o_' + v); } },
    /* AUFTRAG-76 (2.1): Freezer (Lagersystem, Phase, Halsöffnung eng/weit), 2XL (Kanisterzahl), T (Halsöffnung), DS (Datenlogger). Jeder Filter erscheint nur, wenn er innerhalb der Serie unterscheidet. */
    fs: { type: 'chips', param: 'lager', vals: function (r) { var a = []; if (r.fs & 1) a.push('rack'); if (r.fs & 2) a.push('kan'); return a; }, order: ['rack', 'kan'], lab: function (v) { return tx('fs_' + v); } },
    fp: { type: 'chips', param: 'phase', vals: function (r) { var a = []; if (r.fp & 1) a.push('gas'); if (r.fp & 2) a.push('liq'); return a; }, order: ['gas', 'liq'], lab: function (v) { return tx('fp_' + v); } },
    cn: { type: 'chips', param: 'kanister', vals: function (r) { return r.cn > 0 ? [String(r.cn)] : []; }, num: true, lab: function (v) { return fmt(parseFloat(v)); } },
    lg: { type: 'chips', param: 'logger', flag: true, vals: function (r) { return r.lg ? ['log'] : []; }, lab: function () { return tx('lg_log'); } },
    nw: { type: 'chips', param: 'hals', vals: function (r) { return r.nk >= 300 ? [r.nk >= 700 ? 'weit' : 'eng'] : []; }, order: ['eng', 'weit'],
      lab: function (v, rows) {
        var lo = 0, hi = 0;
        rows.forEach(function (r) { if (r.nk >= 300 && (r.nk >= 700) === (v === 'weit')) { if (!lo || r.nk < lo) lo = r.nk; if (r.nk > hi) hi = r.nk; } });
        return tx('nw_' + v) + (lo ? ' (' + fmt(lo) + (hi > lo ? '–' + fmt(hi) : '') + ' mm)' : '');
      } },
    nc: { type: 'chips', param: 'halsmm', vals: function (r) { return r.nk > 0 && r.nk < 300 ? [String(Math.round(r.nk))] : []; }, num: true, lab: function (v) { return fmt(parseFloat(v)) + ' mm'; } },
    zul: { type: 'chips', param: 'zul', flag: true, vals: function (r) { var a = []; if (r.ad) a.push('ADR'); if (r.md) a.push('MDR'); return a; }, order: ['ADR', 'MDR'], lab: function (v) { return v === 'ADR' ? (i18n.adr || 'ADR') : (i18n.mdr || 'MDR'); } }
  };
  var SERIES_ONLY = ['fs', 'fp', 'cn', 'lg', 'nw', 'nc'];
  var PARAM_KEYS = ['vol', 'hold', 'ev', 'ep', 'neck', 'hgt', 'dia', 'wt', 'pr', 'wd', 'probe', 'sys', 'serie', 's', 'druck', 'rollen', 'einsatz', 'bauform', 'druckbar', 'bauart', 'zubehoer', 'zul', 'lager', 'phase', 'kanister', 'logger', 'hals', 'halsmm'];

  function unitText(u) {
    if (u === 'd') return ' ' + tx('days');
    if (u === 'L/d' || u === '%/d') return ' ' + u.slice(0, -1) + (DE ? 'Tag' : 'day');
    return ' ' + u;
  }
  function money(c) {
    if (typeof W.cryonosMoney === 'function') return W.cryonosMoney(c, { noZeros: true });
    return (c / 100).toFixed(0) + ' €';
  }

  /* ---------- Zeilen vorbereiten ---------- */
  function prepRows(data) {
    var rows = (data && data.rows) || [];
    var byKey = {};
    var rowSer = {};
    rows.forEach(function (r) {
      r.types = [];
      if (r.s5 > 0 || r.s2 > 0) r.types.push('straws');
      if (r.vi > 0) r.types.push('vials');
      if (r.c === 'B' && r.vi > 0) r.types.push('kryo');
      if (r.bb > 0) r.types.push('bag');
      r.sysv = (r.c === 'S' || r.c === 'L' || r.c === 'B') ? r.c : '';
      /* AUFTRAG-75: Druckstufe aus der Endung des Modellnamens (Liquid Cylinder), Bauart T aus „AC LIN20T“; nichts geschätzt, sonst leer. */
      var mk = /\s(LP|PB|MP|HP)$/.exec(String(r.n));
      r.kd = (!r.vr && mk) ? mk[1] : '';
      var mb = /^AC [A-Za-z]+\d+(T?)$/.exec(String(r.n));
      r.bau = (!r.vr && mb) ? (mb[1] ? 'T' : 'S') : '';
      /* AUFTRAG-76 (2.2): Liquid Cylinder (Endung LP/PB/MP/HP) und AC L (Name „AC L<Zahl>[-S|-L|-B]“, ohne T-Modelle wie „AC L20T“) zeigen kein ADR-Kennzeichen, bis die Fachprüfung
         custom.adr_transportfaehig bestätigt hat. Die Serie wird aus dem Modellnamen erkannt (wie Druckstufe und Bauart), nicht aus Handles. */
      if (r.kd || /^AC L\d+(-[SLB])?( \(\d+\))?$/.test(String(r.n))) r.ad = 0;
      byKey[r.k] = r;
      rowSer[r.k] = [];
    });
    ((data && data.ser) || []).forEach(function (s) {
      (s.m || []).forEach(function (k) { if (rowSer[k]) rowSer[k].push(s.h); });
    });
    return { rows: rows, byKey: byKey, rowSer: rowSer, ser: (data && data.ser) || [] };
  }
  function cmpRows(a, b) {
    var av = a.v > 0 ? a.v : 1e9, bv = b.v > 0 ? b.v : 1e9;
    if (av !== bv) return av - bv;
    if (a.o !== b.o) { if (!a.o) return 1; if (!b.o) return -1; return a.o < b.o ? -1 : 1; }
    return String(a.n).localeCompare(String(b.n), i18n.lang || 'en', { numeric: true });
  }

  /* ---------- Filtermodell ---------- */
  function Model(P, rows, keys) {
    var self = this;
    this.P = P;
    this.rows = rows;
    this.defs = [];
    this.state = {};
    keys.forEach(function (k) {
      var d = DEF[k];
      if (!d) return;
      if (d.type === 'range') {
        var seen = {}, vals = [];
        rows.forEach(function (r) { var v = r[d.field]; if (v > 0 && !seen[v]) { seen[v] = 1; vals.push(v); } });
        vals.sort(function (a, b) { return a - b; });
        if (vals.length > 1) {
          self.defs.push({ key: k, type: 'range', field: d.field, unit: d.unit, vals: vals, dig: d.fmt || 1 });
          self.state[k] = [0, vals.length - 1];
        }
      } else {
        var opts = [];
        if (k === 'probe') {
          ['straws', 'vials', 'kryo', 'bag'].forEach(function (o) {
            if (rows.some(function (r) { return r.types.indexOf(o) > -1; })) opts.push({ v: o, l: tx(o) });
          });
        } else if (k === 'sys') {
          ['S', 'L', 'B'].forEach(function (o) {
            if (rows.some(function (r) { return r.sysv === o; })) opts.push({ v: o, l: tx(o) });
          });
        } else if (k === 'ser') {
          P.ser.forEach(function (s) {
            if (rows.some(function (r) { return P.rowSer[r.k].indexOf(s.h) > -1; })) opts.push({ v: s.h, l: s.t });
          });
        } else if (d.vals) {
          var seenV = {}, order = [];
          rows.forEach(function (r) { d.vals(r).forEach(function (v) { if (!seenV[v]) { seenV[v] = 1; order.push(v); } }); });
          if (d.num) order.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
          else if (d.order) order.sort(function (a, b) { return d.order.indexOf(a) - d.order.indexOf(b); });
          order.forEach(function (v) { opts.push({ v: v, l: d.lab(v, rows) }); });
          /* Ein Filter erscheint nur, wenn er innerhalb der Serie unterscheidet: mindestens zwei Werte, oder (Zubehör, Zulassung) ein Wert, den nicht alle Modelle haben. */
          var lacks = rows.some(function (r) { return d.vals(r).length === 0; });
          if (!(opts.length > 1 || (d.flag && opts.length === 1 && lacks))) opts = [];
          else if (opts.length === 1) opts.single = true;
        }
        if (opts.length > 1 || opts.single) {
          self.defs.push({ key: k, type: 'chips', opts: opts });
          self.state[k] = [];
        }
      }
    });
    /* AUFTRAG-76 (2.1): Wo eine Auswahl der Halsöffnung (Freezer eng/weit, T in mm) erscheint, entfällt der Regler; wo das Lagersystem schon über
       Kanister/Racks (sys) angeboten wird, entfällt die Freezer-Auswahl gleichen Namens (fs). */
    var has = function (k) { return self.defs.some(function (d) { return d.key === k; }); };
    var drop = function (k) { self.defs = self.defs.filter(function (d) { return d.key !== k; }); delete self.state[k]; };
    if (has('nw') || has('nc')) drop('neck');
    if (has('sys') && has('fs')) drop('fs');
  }
  /* Zeilen im Geltungsbereich der Serienauswahl: Regler ohne einen einzigen Wert darin werden ausgeblendet (F41: Haltezeit bei Freezern, Haltezeit bei Liquid Cylindern). */
  Model.prototype.scopeRows = function () {
    var s = this.state.ser, P = this.P;
    if (!s || !s.length) return this.rows;
    return this.rows.filter(function (r) { return s.some(function (h) { return P.rowSer[r.k].indexOf(h) > -1; }); });
  };
  Model.prototype.isActive = function (d) {
    var s = this.state[d.key];
    return d.type === 'range' ? (s[0] > 0 || s[1] < d.vals.length - 1) : s.length > 0;
  };
  Model.prototype.activeCount = function () {
    var n = 0, self = this;
    this.defs.forEach(function (d) { if (self.isActive(d)) n++; });
    return n;
  };
  Model.prototype.reset = function () {
    var self = this;
    this.defs.forEach(function (d) { self.state[d.key] = d.type === 'range' ? [0, d.vals.length - 1] : []; });
  };
  Model.prototype.match = function (r) {
    var self = this;
    for (var i = 0; i < this.defs.length; i++) {
      var d = this.defs[i], s = this.state[d.key];
      if (!this.isActive(d)) continue;
      if (d.type === 'range') {
        var v = r[d.field];
        if (!(v > 0)) return false;
        if (v < d.vals[s[0]] || v > d.vals[s[1]]) return false;
      } else {
        var ok = false;
        for (var j = 0; j < s.length; j++) {
          if (d.key === 'probe' && r.types.indexOf(s[j]) > -1) ok = true;
          if (d.key === 'sys' && r.sysv === s[j]) ok = true;
          if (d.key === 'ser' && self.P.rowSer[r.k].indexOf(s[j]) > -1) ok = true;
          if (DEF[d.key].vals && DEF[d.key].vals(r).indexOf(s[j]) > -1) ok = true;
        }
        if (!ok) return false;
      }
    }
    return true;
  };
  Model.prototype.split = function () {
    var hits = [], rest = [], self = this;
    this.rows.slice().sort(cmpRows).forEach(function (r) { (self.match(r) ? hits : rest).push(r); });
    return { hits: hits, rest: rest };
  };
  Model.prototype.toParams = function () {
    var out = {}, self = this;
    this.defs.forEach(function (d) {
      if (!self.isActive(d)) return;
      var s = self.state[d.key];
      if (d.type === 'range') out[d.key] = d.vals[s[0]] + '-' + d.vals[s[1]];
      else out[DEF[d.key].param] = s.join(',');
    });
    return out;
  };
  Model.prototype.fromParams = function (q) {
    var self = this;
    this.reset();
    this.defs.forEach(function (d) {
      if (d.type === 'range') {
        var m = /^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/.exec(q.get(d.key) || '');
        if (!m) return;
        var lo = parseFloat(m[1]), hi = parseFloat(m[2]), a = 0, b = d.vals.length - 1, i;
        for (i = 0; i < d.vals.length; i++) { if (d.vals[i] >= lo) { a = i; break; } }
        for (i = d.vals.length - 1; i >= 0; i--) { if (d.vals[i] <= hi) { b = i; break; } }
        if (a > b) b = a;
        self.state[d.key] = [a, b];
      } else {
        var raw = q.get(DEF[d.key].param);
        if (!raw) return;
        var allowed = d.opts.map(function (o) { return o.v; });
        self.state[d.key] = raw.split(',').filter(function (v) { return allowed.indexOf(v) > -1; });
      }
    });
  };

  /* ---------- Regler und Chips ---------- */
  var uid = 0;
  function buildControls(model, host, onChange) {
    var syncers = [];
    host.innerHTML = '';
    model.defs.forEach(function (d) {
      var wrap = D.createElement('div');
      var id = 'rn-c-' + (++uid);
      if (d.type === 'range') {
        wrap.className = 'rn-f__grp rn-rng';
        var n = d.vals.length - 1;
        wrap.innerHTML =
          '<div class="rn-rng__top"><span class="rn-f__lbl" id="' + id + '">' + esc(tx(d.key)) + '</span><output class="rn-rng__out" for="' + id + 'a ' + id + 'b"></output></div>' +
          '<div class="rn-rng__track"><i class="rn-rng__fill"></i>' +
          '<input type="range" id="' + id + 'a" min="0" max="' + n + '" step="1" value="0" aria-label="' + esc(tx(d.key) + ' ' + tx('lo')) + '">' +
          '<input type="range" id="' + id + 'b" min="0" max="' + n + '" step="1" value="' + n + '" aria-label="' + esc(tx(d.key) + ' ' + tx('hi')) + '"></div>';
        var a = $('#' + id + 'a', wrap), b = $('#' + id + 'b', wrap), out = $('.rn-rng__out', wrap), fill = $('.rn-rng__fill', wrap);
        var paint = function () {
          var has = model.scopeRows().some(function (r) { return r[d.field] > 0; });
          if (!has) model.state[d.key] = [0, n];
          wrap.hidden = !has;
          var s = model.state[d.key];
          a.value = s[0]; b.value = s[1];
          var lo = d.vals[s[0]], hi = d.vals[s[1]];
          var ff = d.dig === 2 ? fmt2 : fmt;
          out.textContent = lo === hi ? ff(lo) + unitText(d.unit) : ff(lo) + ' – ' + ff(hi) + unitText(d.unit);
          fill.style.left = (n ? s[0] / n * 100 : 0) + '%';
          fill.style.right = (n ? (n - s[1]) / n * 100 : 0) + '%';
          a.style.zIndex = s[0] > n / 2 ? 4 : 2;
          b.style.zIndex = 3;
          wrap.classList.toggle('is-active', model.isActive(d));
        };
        a.addEventListener('input', function () {
          var v = +a.value; if (v > model.state[d.key][1]) v = model.state[d.key][1];
          model.state[d.key][0] = v; paint(); onChange();
        });
        b.addEventListener('input', function () {
          var v = +b.value; if (v < model.state[d.key][0]) v = model.state[d.key][0];
          model.state[d.key][1] = v; paint(); onChange();
        });
        syncers.push(paint);
      } else {
        wrap.className = 'rn-f__grp rn-chipgrp';
        wrap.setAttribute('role', 'group');
        wrap.setAttribute('aria-labelledby', id);
        wrap.innerHTML = '<span class="rn-f__lbl" id="' + id + '">' + esc(tx(d.key)) + '</span><div class="rn-chips"></div>';
        var box = $('.rn-chips', wrap);
        d.opts.forEach(function (o) {
          var btn = D.createElement('button');
          btn.type = 'button';
          btn.className = 'rn-chip';
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('data-v', o.v);
          btn.textContent = o.l;
          btn.addEventListener('click', function () {
            var s = model.state[d.key], i = s.indexOf(o.v);
            if (i > -1) s.splice(i, 1); else s.push(o.v);
            paintChips();
            if (d.key === 'ser') syncers.forEach(function (f) { f(); });
            onChange();
          });
          box.appendChild(btn);
        });
        var paintChips = function () {
          var s = model.state[d.key];
          $$('.rn-chip', box).forEach(function (btn) { btn.setAttribute('aria-pressed', s.indexOf(btn.getAttribute('data-v')) > -1 ? 'true' : 'false'); });
          wrap.classList.toggle('is-active', s.length > 0);
        };
        syncers.push(paintChips);
      }
      host.appendChild(wrap);
    });
    var all = function () { syncers.forEach(function (f) { f(); }); };
    all();
    return all;
  }

  /* ---------- Werte einer Zeile ---------- */
  function probeText(r) {
    var parts = [], up = r.grp ? esc(T.upto || 'up to') + ' ' : '';
    var sv = r.s5 > 0 ? r.s5 : r.s2;
    if (sv > 0) parts.push(tx(r.s5 > 0 ? 's05' : 's025') + ': ' + up + '<b>' + fmt(sv) + '</b>');
    if (r.vi > 0) parts.push(tx('v2') + ': ' + up + '<b>' + fmt(r.vi) + '</b>');
    return parts.join('<br>');
  }
  function cellFor(col, r) {
    switch (col) {
      case 'vol': return r.v > 0 ? '<b>' + fmt(r.v) + '</b> L' : '';
      case 'probe': return probeText(r);
      case 'hold': return r.hd > 0 ? '<b>' + fmt(r.hd) + '</b>' + esc(unitText('d')) : '';
      case 'ev': return r.ev > 0 ? '<b>' + fmt2(r.ev) + '</b>' + esc(unitText('L/d')) : '';
      case 'ep': return r.ep > 0 ? '<b>' + fmt2(r.ep) + '</b>' + esc(unitText('%/d')) : '';
      case 'neck': return r.nk > 0 ? '<b>' + fmt(r.nk) + '</b> mm' : '';
      case 'hgt': return r.ht > 0 ? '<b>' + fmt(r.ht) + '</b> mm' : '';
      case 'dia': return r.dm > 0 ? '<b>' + fmt(r.dm) + '</b> mm' : '';
      case 'wt': return r.wt > 0 ? '<b>' + fmt(r.wt) + '</b> kg' : '';
      case 'pr': return r.pr > 0 ? '<b>' + fmt(r.pr) + '</b> bar' : '';
      case 'wd': return r.wd > 0 ? '<b>' + fmt(r.wd) + '</b> L/min' : '';
      case 'kd': return r.kd ? '<b>' + esc(r.kd) + '</b>' + (r.pr > 0 ? ' ' + fmt(r.pr) + ' bar' : '') + (r.kd === 'PB' ? '<br>' + esc(tx('pbnote')) : '') : '';
      case 'roll': return r.kd ? esc(tx(r.ct > 0 ? 'withc' : 'woc')) : '';
      case 'use': return r.vr ? esc(tx('u_' + (r.ad ? 'adr' : 'fix'))) : '';
      case 'form': return r.vr ? esc(tx('f_' + (r.hz ? 'h' : 'v'))) : '';
      case 'bar': return r.vr && r.pr > 0 ? '<b>' + fmt(r.pr) + '</b> bar' : '';
      case 'bau': return r.bau ? esc(tx('b_' + r.bau.toLowerCase())) : '';
      case 'opt': return r.ax > 0 ? ((r.ax & 1 ? esc(tx('o_heber')) : '') + (r.ax === 3 ? '<br>' : '') + (r.ax & 2 ? esc(tx('o_kf')) : '')) : '';
    }
    return '';
  }
  function colLabel(col) { return col === 'probe' ? tx('samples') : tx(col); }
  function pickCols(rows, wanted, max) {
    var out = [];
    wanted.forEach(function (c) {
      if (out.length >= max) return;
      if (rows.some(function (r) { return cellFor(c, r) !== ''; })) out.push(c);
    });
    return out;
  }
  function priceText(r) {
    if (!(r.p > 0)) return esc(i18n.req || '');
    return (r.pv || r.vr ? esc(tx('from')) + ' ' : '') + esc(money(r.p));
  }

  /* ---------- Vergleich (gleicher Speicher wie die Vergleichsseite) ---------- */
  var CMP_KEY = 'cryonosCompare', CMP_MAX = 4;
  function cmpRead() {
    try { var l = JSON.parse(localStorage.getItem(CMP_KEY) || '[]'); return Array.isArray(l) ? l.slice(0, CMP_MAX) : []; } catch (e) { return []; }
  }
  function cmpWrite(l) { try { localStorage.setItem(CMP_KEY, JSON.stringify(l)); } catch (e) { /* ohne Speicher kein Vergleich */ } }

  /* ---------- Adresse ---------- */
  function urlSet(area, params) {
    try {
      var u = new URL(W.location.href);
      u.searchParams.delete('bereich'); u.searchParams.delete('ansicht');
      PARAM_KEYS.forEach(function (k) { u.searchParams.delete(k); });
      if (area) {
        u.searchParams.set('bereich', area);
        Object.keys(params || {}).forEach(function (k) { u.searchParams.set(k, params[k]); });
      }
      W.history.replaceState(W.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) { /* ältere Browser: kein Teilen der Adresse */ }
  }

  /* ---------- Bereichs-Finder ---------- */
  /* Gruppen (F38, 15.10.2026): je Nenngröße eine Zeile (AC L20), darunter die Optionsprodukte (-S/-L/-B) aufklappbar.
     Gruppenschlüssel = Modellname ohne die Endung -S/-L/-B; Micro-Bulk-Varianten und Modelle ohne Endung bleiben einzelne Zeilen. */
  var OPT_END = /-(S|L|B)(?=\s*\(|$)/;
  function buildGroups(rows) {
    var map = {}, list = [];
    rows.slice().sort(cmpRows).forEach(function (r) {
      var key = (!r.vr && OPT_END.test(String(r.n))) ? String(r.n).replace(OPT_END, '') : r.k;
      if (!map[key]) { map[key] = { key: key, base: key, rows: [] }; list.push(map[key]); }
      map[key].rows.push(r);
    });
    list.forEach(function (g) {
      var f = g.rows[0], n = g.rows.length;
      if (n === 1) { g.rep = f; return; }
      var rep = {}, k;
      for (k in f) rep[k] = f[k];
      rep.n = g.base; rep.grp = true;
      rep.s5 = 0; rep.s2 = 0; rep.vi = 0; rep.p = 0; rep.pv = false;
      g.rows.forEach(function (r) {
        if (r.s5 > rep.s5) rep.s5 = r.s5;
        if (r.s2 > rep.s2) rep.s2 = r.s2;
        if (r.vi > rep.vi) rep.vi = r.vi;
        if (r.p > 0 && (rep.p === 0 || r.p < rep.p)) rep.p = r.p;
        ['hd', 'ev', 'ep', 'nk', 'ht', 'dm', 'wt', 'pr', 'wd'].forEach(function (c) { if (!(rep[c] > 0) && r[c] > 0) rep[c] = r[c]; });
      });
      rep.pv = true;
      g.rep = rep;
    });
    return list;
  }

  function AreaFinder(host, data, conf, ctx) {
    var P = prepRows(data);
    this.P = P;
    this.ctx = ctx || {};
    var all = P.rows;
    if (conf.hideT) all = all.filter(function (r) { return !r.t; });
    this.rowsAll = all;
    this.groups = buildGroups(all);
    /* AUFTRAG-76: Filter, die nur innerhalb einer Serie Sinn haben (Freezer, 2XL, T, DS), gibt es im Bereichs-Finder ohne Serie nicht. */
    var fkeys = (conf.filters || []).filter(Boolean);
    if (!(ctx && ctx.s)) fkeys = fkeys.filter(function (k) { return SERIES_ONLY.indexOf(k) < 0; });
    this.model = new Model(P, all, fkeys);
    this.want = (conf.cols || ['vol', 'probe', 'hold', 'neck']).filter(Boolean);
    this.maxCols = 5;
    this.area = conf.area;
    this.limit = 12;
    this.limitRest = 12;
    this.openG = {};
    this.host = host;
    this.build();
  }
  /* Spalten nach den gerade gezeigten Zeilen: eine Spalte ohne einen einzigen Wert (z. B. Haltezeit bei Liquid Cylindern) entfällt. */
  AreaFinder.prototype.colsFor = function (reps) {
    var out = [];
    this.want.forEach(function (c) {
      if (out.length >= 5) return;
      if (reps.some(function (r) { return cellFor(c, r) !== ''; })) out.push(c);
    });
    return out;
  };
  AreaFinder.prototype.build = function () {
    var self = this, host = this.host, m = this.model;
    var uidc = 'rn-fc-' + (++uid);
    host.innerHTML =
      '<div class="rn-f">' +
      '<div class="rn-f__bar">' +
      '<button type="button" class="rn-f__toggle" aria-expanded="false" aria-controls="' + uidc + '"><span class="rn-f__tl"></span></button>' +
      '<div class="rn-f__controls" id="' + uidc + '"><div class="rn-f__ctl"></div>' +
      '<button type="button" class="rn-btn rn-btn--line rn-btn--sm rn-f__reset">' + esc(T.reset || 'Reset') + '</button></div>' +
      '</div>' +
      '<div class="rn-f__res">' +
      '<p class="rn-f__count" role="status" aria-live="polite"></p>' +
      '<ol class="rn-f__list"></ol>' +
      '<button type="button" class="rn-btn rn-btn--line rn-btn--sm rn-f__more" hidden></button>' +
      '<details class="rn-f__rest" hidden><summary></summary><ol class="rn-f__list rn-f__list--rest"></ol>' +
      '<button type="button" class="rn-btn rn-btn--line rn-btn--sm rn-f__more2" hidden></button></details>' +
      '<p class="rn-f__empty" hidden>' + esc(T.empty || '') + '</p>' +
      '<p class="rn-f__cmp" hidden><a class="rn-btn rn-btn--gold rn-btn--sm" href="' + esc(i18n.compare_url || '#') + '"></a></p>' +
      '<p class="rn-f__note">' + esc(i18n.note || '') + '</p>' +
      '</div></div>';
    this.el = {
      toggle: $('.rn-f__toggle', host), tl: $('.rn-f__tl', host), controls: $('.rn-f__controls', host),
      count: $('.rn-f__count', host), list: $('.rn-f__list', host), more: $('.rn-f__more', host),
      rest: $('.rn-f__rest', host), restList: $('.rn-f__list--rest', host), more2: $('.rn-f__more2', host),
      empty: $('.rn-f__empty', host), cmp: $('.rn-f__cmp', host)
    };
    this.sync = buildControls(m, $('.rn-f__ctl', host), function () { self.limit = 12; self.limitRest = 12; self.render(); self.save(); });
    $('.rn-f__reset', host).addEventListener('click', function () { m.reset(); self.sync(); self.limit = 12; self.limitRest = 12; self.render(); self.save(); });
    this.el.toggle.addEventListener('click', function () {
      var open = self.el.controls.classList.toggle('is-open');
      self.el.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    this.el.more.addEventListener('click', function () { self.limit = 1e9; self.render(); });
    this.el.more2.addEventListener('click', function () { self.limitRest = 1e9; self.render(); });
    this.el.rest.addEventListener('toggle', function () { if (self.el.rest.open) self.render(); });
    host.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-rn-grp]') : null;
      if (!b) return;
      var key = b.getAttribute('data-rn-grp'), li = b.closest('li'), sub = $('.rn-sub', li);
      var open = !self.openG[key];
      self.openG[key] = open;
      $$('[data-rn-grp="' + key.replace(/"/g, '\\"') + '"]', li).forEach(function (x) { x.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      li.classList.toggle('is-open', open);
      if (sub) sub.hidden = !open;
    });
    host.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('input[data-cmp]')) return;
      var h = t.getAttribute('data-cmp'), l = cmpRead(), i = l.indexOf(h);
      if (t.checked && i === -1 && l.length < CMP_MAX) l.push(h);
      if (!t.checked && i > -1) l.splice(i, 1);
      cmpWrite(l);
      self.paintCompare();
    });
    this.render();
  };
  /* AUFTRAG-75: ADR- und MDR-Kennzeichen einer Zeile, nur wo das Produktfeld gesetzt ist (Wortlaut aus den Sprachdateien buy.card.adr / buy.card.mdr). */
  function tagsHtml(list) {
    var md = list.some(function (r) { return r.md; }), ad = list.some(function (r) { return r.ad; });
    if (!md && !ad) return '';
    return '<span class="rn-tags">' + (md ? '<i>' + esc(i18n.mdr || 'MDR') + '</i>' : '') + (ad ? '<i class="is-g">' + esc(i18n.adr || 'ADR') + '</i>' : '') + '</span>';
  }
  AreaFinder.prototype.rowHtml = function (r, miss, cols, isSub) {
    var vals = cols.map(function (c) {
      var t = cellFor(c, r);
      return '<div><dt>' + esc(colLabel(c)) + '</dt><dd>' + (t || '<span class="rn-na">–</span>') + '</dd></div>';
    }).join('');
    var img = r.i ? '<img src="' + esc(r.i) + '" alt="" width="96" height="96" loading="lazy" decoding="async">' : '';
    var acts = '<a class="rn-btn rn-btn--line rn-btn--sm" href="' + esc(r.u) + '" aria-label="' + esc((T.view || 'View') + ': ' + r.n) + '">' + esc(T.view || 'View') + '</a>';
    if (!r.vr) {
      acts += '<label class="rn-cmp"><input type="checkbox" data-cmp="' + esc(r.h) + '"><span>' + esc(T.compare || 'Compare') + '</span></label>';
    }
    return '<li class="rn-row' + (miss ? ' is-miss' : '') + (isSub ? ' rn-row--sub' : '') + '" style="--rn-cols:' + cols.length + '">' +
      '<div class="rn-row__img">' + img + '</div>' +
      '<div class="rn-row__name"><a href="' + esc(r.u) + '">' + esc(r.n) + '</a>' + tagsHtml([r]) + '</div>' +
      '<dl class="rn-row__vals">' + vals + '</dl>' +
      '<div class="rn-row__price">' + priceText(r) + '</div>' +
      '<div class="rn-row__acts">' + acts + '</div></li>';
  };
  AreaFinder.prototype.groupHtml = function (g, miss, cols) {
    var self = this, m = this.model, r = g.rep, open = !!this.openG[g.key], active = m.activeCount() > 0;
    var vals = cols.map(function (c) {
      var t = cellFor(c, r);
      return '<div><dt>' + esc(colLabel(c)) + '</dt><dd>' + (t || '<span class="rn-na">–</span>') + '</dd></div>';
    }).join('');
    var img = r.i ? '<img src="' + esc(r.i) + '" alt="" width="96" height="96" loading="lazy" decoding="async">' : '';
    var k = esc(g.key);
    var subs = g.rows.map(function (o) { return self.rowHtml(o, active && !m.match(o), cols, true); }).join('');
    var label = sub(T.options || 'Options ({n})', { n: g.rows.length });
    return '<li class="rn-row rn-row--group' + (miss ? ' is-miss' : '') + (open ? ' is-open' : '') + '" style="--rn-cols:' + cols.length + '">' +
      '<div class="rn-row__img">' + img + '</div>' +
      '<div class="rn-row__name"><button type="button" class="rn-row__namebtn" data-rn-grp="' + k + '" aria-expanded="' + (open ? 'true' : 'false') + '">' + esc(g.base) + '</button>' + tagsHtml(g.rows) + '</div>' +
      '<dl class="rn-row__vals">' + vals + '</dl>' +
      '<div class="rn-row__price">' + priceText(r) + '</div>' +
      '<div class="rn-row__acts"><button type="button" class="rn-btn rn-btn--line rn-btn--sm rn-row__opt" data-rn-grp="' + k + '" aria-expanded="' + (open ? 'true' : 'false') + '">' + esc(label) + ' <span aria-hidden="true">▾</span></button></div>' +
      '<ol class="rn-sub" ' + (open ? '' : 'hidden') + '>' + subs + '</ol></li>';
  };
  AreaFinder.prototype.render = function () {
    var m = this.model, el = this.el, self = this;
    var hits = [], rest = [];
    this.groups.forEach(function (g) {
      (g.rows.some(function (r) { return m.match(r); }) ? hits : rest).push(g);
    });
    var n = m.activeCount();
    /* Zählung in Modellen (Produkten), wie die Eckdaten der Kachel; die Liste zeigt eine Zeile je Nenngröße. */
    function cnt(list) { return list.reduce(function (a, g) { return a + g.rows.filter(function (r) { return m.match(r) || list === rest; }).length; }, 0); }
    var nHits = cnt(hits), nRest = cnt(rest);
    var shownHits = hits.slice(0, this.limit);
    var restOpen = el.rest.open && n > 0 && rest.length > 0;
    var shownRest = restOpen ? rest.slice(0, this.limitRest) : [];
    var cols = this.colsFor(shownHits.concat(shownRest).map(function (g) { return g.rep; }));
    if (!cols.length) cols = this.colsFor(this.groups.map(function (g) { return g.rep; }));
    function html(g, miss) { return g.rows.length > 1 ? self.groupHtml(g, miss, cols) : self.rowHtml(g.rows[0], miss, cols, false); }
    el.tl.textContent = (T.filters || 'Filter') + (n ? ' (' + n + ')' : '');
    el.count.innerHTML = '<b>' + sub(esc(T.hits || '{n} of {t} models match'), { n: nHits, t: this.rowsAll.length }) + '</b>';
    el.list.innerHTML = shownHits.map(function (g) { return html(g, false); }).join('');
    el.more.hidden = hits.length <= this.limit;
    if (!el.more.hidden) el.more.textContent = sub(T.showmore || 'Show all {n} models', { n: nHits });
    el.empty.hidden = hits.length > 0;
    var hasRest = n > 0 && rest.length > 0;
    el.rest.hidden = !hasRest;
    if (hasRest) {
      $('summary', el.rest).textContent = sub(T.others || 'Other models ({n})', { n: nRest });
      if (el.rest.open) {
        el.restList.innerHTML = shownRest.map(function (g) { return html(g, true); }).join('');
        el.more2.hidden = rest.length <= this.limitRest;
        if (!el.more2.hidden) el.more2.textContent = sub(T.showmore || 'Show all {n} models', { n: nRest });
      }
    } else {
      el.rest.open = false;
    }
    this.paintCompare();
  };
  AreaFinder.prototype.paintCompare = function () {
    var l = cmpRead(), full = l.length >= CMP_MAX;
    $$('input[data-cmp]', this.host).forEach(function (cb) {
      var on = l.indexOf(cb.getAttribute('data-cmp')) > -1;
      cb.checked = on;
      cb.disabled = full && !on;
      cb.title = full && !on ? tx('max4') : '';
    });
    var p = this.el.cmp;
    p.hidden = l.length === 0;
    if (l.length) $('a', p).textContent = sub(T.compare_open || 'Open comparison ({n})', { n: l.length });
  };
  AreaFinder.prototype.params = function () {
    var p = this.model.toParams();
    if (this.ctx && this.ctx.s) p.s = this.ctx.s;
    return p;
  };
  AreaFinder.prototype.save = function () {
    urlSet(this.area, this.params());
    track('range_finder_filter', { area: this.area, series: this.ctx && this.ctx.s, filters: this.model.activeCount() });
  };
  AreaFinder.prototype.load = function (q) {
    this.model.fromParams(q);
    this.sync();
    this.render();
    if (this.model.activeCount() > 0) {
      this.el.controls.classList.add('is-open');
      this.el.toggle.setAttribute('aria-expanded', 'true');
    }
    urlSet(this.area, this.params());
  };

  /* ---------- Serien-Finder (Tabelle) ---------- */
  function SeriesFinder(host, data, conf, seriesHandle) {
    var P = prepRows(data), self = this;
    var ser = null;
    P.ser.forEach(function (s) { if (s.h === seriesHandle) ser = s; });
    var rows = [];
    if (ser) ser.m.forEach(function (k) { if (P.byKey[k]) rows.push(P.byKey[k]); });
    this.rows = rows.sort(cmpRows);
    this.ser = ser;
    var keys = (conf.filters || []).filter(function (k) { return k && k !== 'ser'; });
    this.model = new Model(P, rows, keys);
    this.cols = pickCols(rows, conf.cols || ['vol', 'probe', 'hold', 'neck'], 6);
    this.host = host;
    host.innerHTML =
      '<div class="rn-sf__in">' +
      '<div class="rn-sf__head"><p class="rn-sf__title">' + esc((T.find_model || 'Find a model') + ': ' + (ser ? ser.t : '')) + '</p>' +
      '<button type="button" class="rn-panel__close" data-rn-sf-close aria-label="' + esc(T.close || 'Close') + '"><span aria-hidden="true">×</span></button></div>' +
      '<div class="rn-f__controls is-open rn-sf__ctl"></div>' +
      '<p class="rn-f__count" role="status" aria-live="polite"></p>' +
      '<div class="rn-sf__tablewrap"><table class="rn-sf__table"><thead></thead><tbody></tbody></table></div>' +
      '<p class="rn-f__note">' + esc(i18n.note || '') + '</p></div>';
    this.sync = buildControls(this.model, $('.rn-sf__ctl', host), function () { self.render(); });
    var reset = D.createElement('button');
    reset.type = 'button'; reset.className = 'rn-btn rn-btn--line rn-btn--sm rn-f__reset'; reset.textContent = T.reset || 'Reset';
    reset.addEventListener('click', function () { self.model.reset(); self.sync(); self.render(); });
    $('.rn-sf__ctl', host).appendChild(reset);
    var head = '<tr><th scope="col">' + esc(tx('model')) + '</th>' + this.cols.map(function (c) { return '<th scope="col">' + esc(colLabel(c)) + '</th>'; }).join('') +
      '<th scope="col">' + esc(tx('price')) + '</th><th scope="col"><span class="rn-vh">' + esc(T.view || 'View') + '</span></th></tr>';
    $('thead', host).innerHTML = head;
    this.render();
  }
  SeriesFinder.prototype.render = function () {
    var m = this.model, cols = this.cols, active = m.activeCount() > 0, hits = 0, html = '';
    this.rows.forEach(function (r) {
      var hit = m.match(r);
      if (hit) hits++;
      html += '<tr class="' + (active ? (hit ? 'is-hit' : 'is-dim') : '') + '"><th scope="row"><a href="' + esc(r.u) + '">' + esc(r.n) + '</a></th>' +
        cols.map(function (c) { var t = cellFor(c, r); return '<td>' + (t || '<span class="rn-na">–</span>') + '</td>'; }).join('') +
        '<td>' + priceText(r) + '</td>' +
        '<td><a class="rn-btn rn-btn--line rn-btn--sm" href="' + esc(r.u) + '" aria-label="' + esc((T.view || 'View') + ': ' + r.n) + '">' + esc(T.view || 'View') + '</a></td></tr>';
    });
    $('tbody', this.host).innerHTML = html;
    $('.rn-f__count', this.host).innerHTML = '<b>' + sub(esc(T.hits || '{n} of {t} models match'), { n: active ? hits : this.rows.length, t: this.rows.length }) + '</b>';
  };

  /* ---------- Navigator: Kacheln und Panels ---------- */
  function Navigator(root) {
    var self = this;
    this.root = root;
    this.grid = $('[data-rn-grid]', root);
    this.tiles = $$('[data-rn-tile]', root);
    this.panels = {};
    this.open = null;
    $$('[data-rn-panel]', root).forEach(function (p) { self.panels[p.getAttribute('data-rn-tile-id')] = p; });
    this.finders = {};
    this.sfinders = {};

    this.tiles.forEach(function (tile) {
      var panel = self.panels[tile.id];
      if (!panel) return;
      $$('[data-rn-open]', tile).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var view = btn.getAttribute('data-rn-open');
          if (self.open && self.open.tile === tile && self.open.view === view) self.close(true);
          else self.show(tile, view, true);
        });
      });
    });
    $$('[data-rn-tab]', root).forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panel = tab.closest('[data-rn-panel]');
        self.show(D.getElementById(panel.getAttribute('data-rn-tile-id')), tab.getAttribute('data-rn-tab'), false);
      });
    });
    $$('[data-rn-close]', root).forEach(function (b) { b.addEventListener('click', function () { self.close(true); }); });
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.open) {
        var sfOpen = $('[data-rn-sfinder]:not([hidden])', self.open.panel);
        if (sfOpen) { self.closeSeriesFinder(self.open.panel); return; }
        self.close(true);
      }
    });
    $$('[data-rn-series-find]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { self.seriesFinder(btn); });
    });
    var rt;
    W.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (self.open) self.place(self.open.tile, self.open.panel); }, 150);
    });
    this.fromUrl();
  }
  Navigator.prototype.place = function (tile, panel) {
    var last = tile, found = false, top = tile.offsetTop;
    this.tiles.forEach(function (t) {
      if (t === tile) { found = true; return; }
      if (found && t.offsetTop === top) last = t;
    });
    if (last.nextElementSibling !== panel) last.insertAdjacentElement('afterend', panel);
  };
  Navigator.prototype.finderFor = function (panel) {
    var id = panel.id;
    if (this.finders[id]) return this.finders[id];
    var host = $('[data-rn-finder]', panel), dEl = $('[data-rn-data]', panel), cEl = $('[data-rn-conf]', panel);
    if (!host || !dEl || !cEl) return null;
    var data, conf;
    try { data = JSON.parse(dEl.textContent); conf = JSON.parse(cEl.textContent); } catch (e) { return null; }
    this.finders[id] = new AreaFinder(host, data, conf);
    return this.finders[id];
  };
  Navigator.prototype.show = function (tile, view, focusPanel) {
    var self = this, panel = this.panels[tile.id];
    if (!panel) return;
    if (view === 'finder' && !$('[data-rn-view="finder"]', panel)) view = 'series';
    if (this.open && this.open.tile !== tile) this.close(false);
    this.place(tile, panel);
    panel.classList.add('is-open');
    tile.classList.add('is-active');
    $$('[data-rn-view]', panel).forEach(function (v) { v.classList.toggle('is-on', v.getAttribute('data-rn-view') === view); });
    $$('[data-rn-tab]', panel).forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-rn-tab') === view ? 'true' : 'false'); });
    $$('[data-rn-open]', tile).forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-rn-open') === view ? 'true' : 'false'); });
    var f = null;
    if (view === 'finder') {
      f = this.finderFor(panel);
      urlSet(tile.getAttribute('data-rn-area'), f ? f.model.toParams() : {});
    } else {
      urlSet(tile.getAttribute('data-rn-area'), {});
      try { var u = new URL(W.location.href); u.searchParams.set('ansicht', 'serien'); W.history.replaceState(W.history.state, '', u.pathname + u.search + u.hash); } catch (e) { /* egal */ }
    }
    this.open = { tile: tile, panel: panel, view: view };
    track('range_nav_open', { area: tile.getAttribute('data-rn-area'), view: view });
    if (focusPanel) {
      var r = panel.getBoundingClientRect();
      if (r.top < 0 || r.top > W.innerHeight * 0.7) panel.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' });
    }
  };
  Navigator.prototype.close = function (restoreFocus) {
    if (!this.open) return;
    var o = this.open;
    o.panel.classList.remove('is-open');
    o.tile.classList.remove('is-active');
    $$('[data-rn-open]', o.tile).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    this.closeSeriesFinder(o.panel);
    this.open = null;
    urlSet(null);
    if (restoreFocus) {
      var b = $('[data-rn-open="' + o.view + '"]', o.tile) || $('[data-rn-open]', o.tile);
      if (b) b.focus();
    }
  };
  Navigator.prototype.seriesFinder = function (btn) {
    var panel = btn.closest('[data-rn-panel]'), host = $('[data-rn-sfinder]', panel);
    var handle = btn.getAttribute('data-rn-series-find');
    var dEl = $('[data-rn-data]', panel), cEl = $('[data-rn-conf]', panel);
    if (!host || !dEl || !cEl) return;
    if (!host.hidden && host.getAttribute('data-series') === handle) { this.closeSeriesFinder(panel); return; }
    this.closeSeriesFinder(panel);
    var data, conf;
    try { data = JSON.parse(dEl.textContent); conf = JSON.parse(cEl.textContent); } catch (e) { return; }
    var self = this;
    var sf = new SeriesFinder(host, data, conf, handle);
    host.setAttribute('data-series', handle);
    host.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    $('[data-rn-sf-close]', host).addEventListener('click', function () { self.closeSeriesFinder(panel); btn.focus(); });
    this.sfinders[panel.id] = sf;
    track('range_series_finder_open', { series: handle });
    host.scrollIntoView({ block: 'nearest', behavior: REDUCED ? 'auto' : 'smooth' });
  };
  Navigator.prototype.closeSeriesFinder = function (panel) {
    var host = $('[data-rn-sfinder]', panel);
    if (host) { host.hidden = true; host.innerHTML = ''; host.removeAttribute('data-series'); }
    $$('[data-rn-series-find]', panel).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  };
  Navigator.prototype.fromUrl = function () {
    var q;
    try { q = new URL(W.location.href).searchParams; } catch (e) { return; }
    var area = q.get('bereich');
    if (!area) return;
    var tile = null;
    this.tiles.forEach(function (t) { if (t.getAttribute('data-rn-area') === String(parseInt(area, 10))) tile = t; });
    if (!tile || !this.panels[tile.id]) return;
    var wantSeries = q.get('ansicht') === 'serien';
    var self = this;
    var go = function () {
      self.show(tile, wantSeries ? 'series' : 'finder', false);
      if (!wantSeries && self.finders[self.panels[tile.id].id]) self.finders[self.panels[tile.id].id].load(q);
      var rect = tile.getBoundingClientRect();
      W.scrollTo({ top: Math.max(0, rect.top + W.pageYOffset - 140), behavior: 'auto' });
    };
    if (D.readyState === 'complete') go(); else W.addEventListener('load', go);
  };


  /* ---------- Querbänder (AUFTRAG-62): Serienkarte öffnet unter dem Band Filter und Modellliste dieser Serie ---------- */
  /* Ein JSON für die ganze Section ({"1":{rows,ser},"2":…}); je Band ein Panel mit eigenem Titel und Schließen-Knopf.
     Es ist höchstens ein Panel offen. Tastatur: Knopf je Karte (aria-expanded/aria-controls), Escape schließt, der Fokus
     springt in den Panelkopf und kehrt beim Schließen auf den Knopf der Karte zurück. */
  function Bands(root) {
    var self = this;
    this.root = root;
    this.open = null;
    W.__rnBands = this;
    this.data = {};
    try { this.data = JSON.parse($('[data-rn-data]', root).textContent) || {}; } catch (e) { this.data = {}; }
    this.bands = $$('[data-rn-band]', root);
    this.bands.forEach(function (band) {
      $$('[data-rn-series-open]', band).forEach(function (btn) {
        btn.addEventListener('click', function () { self.toggle(band, btn.getAttribute('data-rn-series-open'), btn, true); });
      });
      var close = $('[data-rn-close]', band);
      if (close) close.addEventListener('click', function () { self.close(true); });
    });
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.open) self.close(true);
    });
    var rt;
    W.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (self.open) self.placeNotch(self.open.panel, self.open.btn); }, 120);
    });
    this.fromUrl();
  }
  /* Kerbe im Kopfstreifen des Panels genau unter der gewählten Serien-Kachel (AUFTRAG-75, Punkt 4). */
  Bands.prototype.placeNotch = function (panel, btn) {
    var n = $('[data-rn-notch]', panel), card = btn && btn.closest ? btn.closest('.rn-scard') : null;
    if (!n || !card) return;
    var c = card.getBoundingClientRect(), p = panel.getBoundingClientRect();
    n.style.left = Math.round(c.left + c.width / 2 - p.left) + 'px';
  };
  Bands.prototype.toggle = function (band, handle, btn, focusPanel) {
    if (this.open && this.open.band === band && this.open.handle === handle) { this.close(true); return; }
    this.show(band, handle, btn, focusPanel);
  };
  Bands.prototype.finderFor = function (band, panel, handle) {
    var area = band.getAttribute('data-rn-area');
    var all = this.data[area];
    var wrap = $('[data-rn-finders]', panel);
    var host = null;
    $$('[data-rn-finder-host]', wrap).forEach(function (h) { if (h.getAttribute('data-rn-finder-host') === handle) host = h; });
    if (host) return { host: host, finder: host.__finder };
    var cEl = $('[data-rn-conf]', panel), conf = {};
    try { conf = JSON.parse(cEl.textContent); } catch (e) { conf = {}; }
    var ser = null;
    ((all && all.ser) || []).forEach(function (s) { if (s.h === handle) ser = s; });
    if (!ser) return null;
    var keep = {};
    ser.m.forEach(function (k) { keep[k] = 1; });
    var data = { rows: ((all && all.rows) || []).filter(function (r) { return keep[r.k]; }), ser: [ser] };
    host = D.createElement('div');
    host.setAttribute('data-rn-finder-host', handle);
    wrap.appendChild(host);
    var filters = (conf.filters || []).filter(function (k) { return k && k !== 'ser'; });
    host.__finder = new AreaFinder(host, data, { area: conf.area, filters: filters, cols: conf.cols, hideT: false }, { s: handle });
    host.__ser = ser;
    return { host: host, finder: host.__finder };
  };
  Bands.prototype.show = function (band, handle, btn, focusPanel) {
    var panel = $('[data-rn-panel]', band);
    if (!panel) return false;
    if (this.open && this.open.band !== band) this.close(false);
    closeInlineFinder();
    var f = this.finderFor(band, panel, handle);
    if (!f) return false;
    $$('[data-rn-finder-host]', panel).forEach(function (h) { h.hidden = h !== f.host; });
    var ser = f.host.__ser;
    var title = $('[data-rn-ptitle]', panel);
    title.textContent = (T.find_model || 'Find a model') + ': ' + (ser ? ser.t : '');
    var go = $('[data-rn-pgo]', panel);
    if (go && ser && ser.u) go.setAttribute('href', ser.u);
    panel.hidden = false;
    panel.classList.add('is-open');
    $$('[data-rn-series-open]', band).forEach(function (b) {
      var on = b.getAttribute('data-rn-series-open') === handle;
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      var card = b.closest('.rn-scard');
      if (card) card.classList.toggle('is-active', on);
    });
    var opener = btn;
    if (!opener) $$('[data-rn-series-open]', band).forEach(function (b) { if (b.getAttribute('data-rn-series-open') === handle) opener = b; });
    this.open = { band: band, panel: panel, handle: handle, btn: opener };
    this.placeNotch(panel, opener);
    urlSet(band.getAttribute('data-rn-area'), f.finder.params());
    track('range_nav_open', { area: band.getAttribute('data-rn-area'), series: handle });
    if (focusPanel) {
      try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); }
      var r = panel.getBoundingClientRect();
      if (r.top < 0 || r.top > W.innerHeight * 0.6) panel.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' });
    }
    return true;
  };
  Bands.prototype.close = function (restoreFocus) {
    if (!this.open) return;
    var o = this.open;
    o.panel.hidden = true;
    o.panel.classList.remove('is-open');
    $$('[data-rn-series-open]', o.band).forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var card = b.closest('.rn-scard');
      if (card) card.classList.remove('is-active');
    });
    this.open = null;
    urlSet(null);
    if (restoreFocus && o.btn) o.btn.focus();
  };
  Bands.prototype.fromUrl = function () {
    var q, self = this;
    try { q = new URL(W.location.href).searchParams; } catch (e) { return; }
    var area = q.get('bereich'), handle = q.get('s');
    if (!area || !handle) return;
    var band = null;
    this.bands.forEach(function (b) { if (b.getAttribute('data-rn-area') === String(parseInt(area, 10))) band = b; });
    if (!band) return;
    var go = function () {
      if (!self.show(band, handle, null, false)) return;
      var f = self.finderFor(band, $('[data-rn-panel]', band), handle);
      if (f && f.finder) f.finder.load(q);
      var rect = band.getBoundingClientRect();
      W.scrollTo({ top: Math.max(0, rect.top + W.pageYOffset - 100), behavior: 'auto' });
    };
    if (D.readyState === 'complete') go(); else W.addEventListener('load', go);
  };

  W.CryRangeNav = { Model: Model, AreaFinder: AreaFinder, SeriesFinder: SeriesFinder, prepRows: prepRows };

  /* ---------- Finder-Knöpfe der Bereiche (Nachbesserung 16.10.2026) ----------
     „Passendes Modell finden“ und die Finder-Knöpfe 04 bis 06 sind Links auf ?weg=N#product-finder (ohne JavaScript bleibt das so).
     Mit JavaScript öffnen sie den großen Finder dieser Seite an Ort und Stelle: der Wege-Knopf des Finders wird ausgelöst
     (gleicher Pfad wie die Startseiten-Logik: Weg setzen, ?weg in die Adresse ohne Neuladen, scrollen), danach geht der Fokus in den Finder.
     Der Listener hängt am window (nach den Listenern von product-finder.js und finder-inline.js): wurde der Klick dort schon
     behandelt (defaultPrevented), tut er nichts. Ist der Finder noch nicht bereit, wird bis zu drei Sekunden gewartet, dann gilt der Link. */
  function finderRoot() { return D.querySelector('[data-product-finder]'); }
  /* AUFTRAG-75 Punkt 5: Der Finder (eine Instanz, assets/finder-inline.js) wird UNTER die große Kachel gehängt. Offene Serien-Liste und Finder
     schließen sich gegenseitig; im Kopf des Finders steht zusätzlich „Großer Finder →“ (Seite mit dem ganzen Finder, gleicher Weg). */
  function closeInlineFinder() {
    var pn = D.getElementById('pf-inline-panel');
    if (!pn || !pn.parentNode || !pn.closest('[data-rn-root]')) return;
    var cb = pn.querySelector('.pfi-close');
    if (cb) cb.click();
  }
  function decorateInline(n, tries) {
    tries = tries || 0;
    var pn = D.getElementById('pf-inline-panel');
    var head = pn && pn.parentNode ? pn.querySelector('.pfn-head') : null;
    if (!head) { if (tries < 12) setTimeout(function () { decorateInline(n, tries + 1); }, 120); return; }
    var a = head.querySelector('.rn-bigfinder');
    if (!a) {
      a = D.createElement('a');
      a.className = 'rn-btn rn-btn--line rn-btn--sm rn-bigfinder';
      head.insertBefore(a, head.querySelector('.pfi-close'));
    }
    a.textContent = (i18n.big_l || 'Large finder') + ' →';
    a.href = (i18n.big || '/pages/produktfinder') + '?weg=' + n;
    /* Nach dem Aufklappen und Scrollen des Finders: Kopf des Feldes nicht hinter Kopfzeile und Sprungleiste stehen lassen. */
    if (!pn.__rnAdj) {
      pn.__rnAdj = true;
      setTimeout(function () {
        pn.__rnAdj = false;
        if (!pn.parentNode) return;
        var hh = parseInt(getComputedStyle(D.documentElement).getPropertyValue('--header-height'), 10) || 66;
        var want = hh + 56 + 24, top = pn.getBoundingClientRect().top;
        if (top < want) W.scrollBy({ top: top - want, behavior: 'auto' });
      }, REDUCED ? 100 : 900);
    }
  }
  function scrollToFinder(instant) {
    var fr = finderRoot();
    if (!fr) return;
    var target = D.getElementById('product-finder') || fr;
    if (instant) {
      var hh = parseInt(getComputedStyle(D.documentElement).getPropertyValue('--header-height'), 10) || 66;
      W.scrollTo(0, Math.max(0, target.getBoundingClientRect().top + W.pageYOffset - hh - 12));
    } else {
      target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    }
  }
  /* Fokus wie finder-inline.js: erste Antwort des Weges, sonst der Finder selbst; erst wenn der Finder gerendert hat (bis ca. 1,5 s). */
  function focusFinder(tries) {
    var fr = finderRoot();
    if (!fr) return;
    tries = tries || 0;
    var first = fr.querySelector('.pfn-way.on[data-a], .pfn-way[aria-current], .pfn-way[aria-pressed="true"]') || fr.querySelector('[data-pf-app] .pfn-left button[data-a], [data-pf-app] button[data-a], .pfn-way[data-a]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { /* egal */ } if (D.activeElement === first) return; }
    if (tries < 10) { setTimeout(function () { focusFinder(tries + 1); }, 150); return; }
    if (!fr.hasAttribute('tabindex')) fr.setAttribute('tabindex', '-1');
    try { fr.focus({ preventScroll: true }); } catch (e) { /* egal */ }
  }
  function openWay(n, href, tries) {
    var fr = finderRoot();
    tries = tries || 0;
    if (fr && fr.__pfInit) {
      var btn = fr.querySelector('[data-a="way"][data-v="' + n + '"]');
      if (btn) {
        btn.click();
        setTimeout(function () { focusFinder(0); }, REDUCED ? 50 : 500);
        return;
      }
    }
    if (tries < 20) setTimeout(function () { openWay(n, href, tries + 1); }, 150);
    else if (href) W.location.href = href;
  }
  /* finder-inline.js erkennt Kacheln an den Klassen .h58-tile und .rg-pg-head sowie am Datenattribut data-pf-tile (AUFTRAG-76, 2.3):
     die Querkachel der Produktübersicht trägt data-pf-tile im Markup, eine geborgte Klasse gibt es nicht mehr. */
  function bindFinderLinks() {
    W.addEventListener('click', function (e) {
      if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var t = e.target && e.target.closest ? e.target.closest('[data-rn-root] [data-pf-way]') : null;
      if (!t || t.closest('[data-product-finder]')) return;
      var n = t.getAttribute('data-pf-way');
      if (!/^[1-6]$/.test(n) || !finderRoot()) return;
      if (W.__rnBands) W.__rnBands.close(false);
      if (D.getElementById('pf-inline-panel')) decorateInline(n);
      /* product-finder.js (document-Listener) hat den Weg schon gewählt und gescrollt (defaultPrevented):
         dann nur noch den Fokus in den Finder setzen. finder-inline.js (04–06) setzt den Fokus selbst. */
      if (e.defaultPrevented) {
        if (!D.getElementById('pf-inline-panel')) setTimeout(function () { focusFinder(0); }, REDUCED ? 50 : 500);
        return;
      }
      e.preventDefault();
      openWay(n, t.getAttribute('href'));
    });
    /* Direktaufruf ?weg=N (ohne Hash): zum Finder scrollen. Nicht bei geteilten Serien-Links (?bereich=…&s=…). */
    var q = W.location.search || '';
    if (/[?&]weg=[1-6](?:&|#|$)/.test(q) && !/[?&]bereich=/.test(q) && finderRoot()) {
      /* Warten, bis der Finder initialisiert ist (Polling, höchstens 3 s), dann sofort (ohne weiche Animation) zum Finder scrollen;
         die Seite darunter lädt Bilder nach, deshalb wird die Lage nach 500 ms einmal nachgezogen. */
      /* Nicht auf „load“ warten (kommt auf dieser bilderreichen Seite spät): sofort nach DOMContentLoaded starten,
         nach „load“ die Lage einmal nachziehen – aber nur, wenn der Besucher inzwischen nicht selbst gescrollt hat. */
      var tries = 0, gesetzt = -1;
      var wn = (/[?&]weg=([1-6])/.exec(q) || [])[1];
      var kachelBtn = wn ? D.querySelector('[data-rn-root] [data-pf-way="' + wn + '"]') : null;
      var hin = function () {
        if (kachelBtn) {
          /* Der Weg steht unter seiner Kachel: dorthin scrollen (Kachel oben, darunter das Finder-Feld). */
          var card = kachelBtn.closest('.rn-card') || kachelBtn;
          var hh = parseInt(getComputedStyle(D.documentElement).getPropertyValue('--header-height'), 10) || 66;
          W.scrollTo(0, Math.max(0, card.getBoundingClientRect().top + W.pageYOffset - hh - 70));
        } else scrollToFinder(true);
        gesetzt = W.pageYOffset;
      };
      var go = function () {
        var fr = finderRoot();
        if (fr && fr.__pfInit) {
          if (kachelBtn && !D.getElementById('pf-inline-panel')) { kachelBtn.click(); decorateInline(wn); }
          hin();
          setTimeout(function () { if (Math.abs(W.pageYOffset - gesetzt) < 40) hin(); focusFinder(0); }, 500);
          return;
        }
        if (++tries <= 30) setTimeout(go, 100);
        else hin();
      };
      go();
      W.addEventListener('load', function () { if (gesetzt >= 0 && Math.abs(W.pageYOffset - gesetzt) < 40) hin(); });
    }
  }

  /* AUFTRAG-102 NACHTRAG 2 (Thomas 25.10. 19:46): Serien-Knöpfe „Find a model ▾“ / „To the series →“ gleich breit, so schmal wie
     der längste Knopftext der Section, mit gleichem Abstand links, Mitte, rechts (CSS: space-evenly). Die Obergrenze (bisherige
     halbe Kachelbreite) setzt das CSS (max-width), nicht das Script: Beim Start haben eingeblendete Kacheln (.rv) ihre Breite
     noch nicht. Ohne Script: natürliche Breite. */
  function equalChipButtons(root) {
    var acts = $$('.rn-scards--chips .rn-scard__acts', root);
    if (!acts.length) return;
    var btns = [];
    acts.forEach(function (a) { btns = btns.concat($$('.rn-scard__open, .rn-scard__go', a)); });
    btns.forEach(function (b) { b.style.width = ''; });
    var max = 0;
    btns.forEach(function (b) { max = Math.max(max, Math.ceil(b.getBoundingClientRect().width)); });
    if (max > 0) btns.forEach(function (b) { b.style.width = max + 'px'; });
  }

  function init() {
    var roots = $$('[data-rn-root]');
    roots.forEach(function (root) {
      if (root.getAttribute('data-rn-mode') === 'bands') new Bands(root); else new Navigator(root);
      equalChipButtons(root);
    });
    if (roots.length) bindFinderLinks();
    if (roots.length) {
      var t = null, again = function () { roots.forEach(equalChipButtons); };
      W.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(again, 120); });
      if (D.fonts && D.fonts.ready) D.fonts.ready.then(again);
    }
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
